module.exports = __webpack_public_path__ + "static/media/cpg_desktop_instagram_display.ac544f44.png";